/* eslint-disable */
import React, { useState, useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown, Avatar, message } from 'antd'
import { resetAppState, getYs7Token, getJavaToken } from '@/redux/app/appSlice'
import { LogoutOutlined, DownOutlined, SettingOutlined, SyncOutlined } from '@ant-design/icons'
import { clearAllAuth } from '@/utils/logout'
import { mergeClientPermissionCodeLists } from '@/constants/menuPermissionMeta'
import { isMenuItemVisible } from '@/utils/menuItemVisible'
import { syncYingshiDevices, syncYingshiShareDevices } from '@/service/yingshi'

const DropdownMenu = ({ navigate }) => {
  const dispatch = useDispatch()
  const { user, browserType, token, permissionCodes, permissionCodesLoaded } = useSelector(state => state.app)
  const mergedRbacCodes = useMemo(
    () => mergeClientPermissionCodeLists(permissionCodes),
    [permissionCodes]
  )
  // console.log('DropdownMenu', user)
  const [userMenu] = useState([])
  const [fetchingSync, setFetchingSync] = useState('') // '' | 'direct' | 'share'
  const [fetchingEkuaibao] = useState(false) // 同步易快报加载开关

  const logout = useCallback(() => {
    // 先清理 cookie、localStorage 中的 state 与 token 时间戳，再清 Redux
    clearAllAuth(token)
    dispatch(resetAppState())
    navigate('/system/login')
  }, [dispatch, navigate, token])

  const checkMenuVisible = useCallback((menu) => {
    return isMenuItemVisible(menu, mergedRbacCodes, permissionCodesLoaded)
  }, [mergedRbacCodes, permissionCodesLoaded])

  const userFilter = useCallback(menu => {
    if (!menu.user) { return true }
    return menu.user.some(name => name === user.enname)
  }, [user])

  const handleGetYs7Token = () => {
    dispatch(getYs7Token())
  }

  const handleGetJavaToken = () => {
    dispatch(getJavaToken())
  }

  const handleSyncYingshiDevices = async () => {
    if (fetchingSync) return
    setFetchingSync('direct')
    try {
      await syncYingshiDevices()
      message.success('同步设备成功')
    } catch (error) {
      const errMsg =
        (error && typeof error === 'object' && (error.msg || error.message)) || '同步设备失败'
      message.error(String(errMsg))
    } finally {
      setFetchingSync('')
    }
  }

  const handleSyncYingshiShareDevices = async () => {
    if (fetchingSync) return
    setFetchingSync('share')
    try {
      await syncYingshiShareDevices()
      message.success('同步分享设备成功')
    } catch (error) {
      const errMsg =
        (error && typeof error === 'object' && (error.msg || error.message)) || '同步分享设备失败'
      message.error(String(errMsg))
    } finally {
      setFetchingSync('')
    }
  }

  const item = [
    {
      key: '1',
      label: '退出登录',
      onClick: logout,
      icon: <LogoutOutlined />,
      disabled: browserType?.environment === 'dingtalk'
    },
    {
      key: '2',
      label: '预警设置',
      menuCodes: ['service:alerts'],
      onClick: () => {
        navigate('/client/serviceAlertsRulesList')
      },
      icon: <SettingOutlined />
    },
    {
      key: '3',
      label: '萤石云 Token',
      menuCodes: ['service:ys'],
      onClick: handleGetYs7Token,
      icon: <LogoutOutlined />
    },
    {
      key: '4',
      label: 'Java Token',
      menuCodes: ['service:java'],
      onClick: handleGetJavaToken,
      icon: <LogoutOutlined />
    },
    {
      key: '5',
      label: fetchingSync === 'direct' ? '同步设备中…' : '同步摄像头设备',
      menuCodes: ['service:java'],
      onClick: handleSyncYingshiDevices,
      icon: <SyncOutlined spin={fetchingSync === 'direct'} />,
      disabled: fetchingSync === 'direct'
    },
    {
      key: '6',
      label: fetchingSync === 'share' ? '同步分享设备中…' : '同步分享摄像头设备',
      menuCodes: ['service:java'],
      onClick: handleSyncYingshiShareDevices,
      icon: <SyncOutlined spin={fetchingSync === 'share'} />,
      disabled: fetchingSync === 'share'
    }
  ]

  const formatMenus = item
    .filter(menu => checkMenuVisible(menu))
    .filter(menu => userFilter(menu))

  const menuProps = {
    items: formatMenus,
    // onClick: handleMenuClick,
    // selectable: true,
    // defaultSelectedKeys: ['3']
  }

  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      <Dropdown menu={menuProps} trigger={['click']}>
        <span className="action account">
          <Avatar className="avatar" size="small" src={user?.iconpath} />
          <span className="name">{user?.name}</span>
          <DownOutlined/>
        </span>
      </Dropdown>
    </span>
  )
}

export default DropdownMenu
 